<template>
  <div>
    <dx-data-grid
      :data-source="orderData.data._formatted.crmBestellungen"
      :show-borders="true"
      :column-auto-width="true"
      :word-wrap-enabled="true"
      class="master-detail-list"
      no-data-text="No Orders"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :column-min-width="50"
      columnResizingMode="widget"
    >
      <dx-paging :page-size="5"/>

      <dx-column-chooser
        :enabled="true"
        mode="select"
      >
        <dx-column-chooser-search
          :enabled="true"
        />
      </dx-column-chooser>

      <dx-column
        data-field="id"
        caption="ID"
        data-type="number"
        :width="100"
      />
      <dx-column
        data-field="eventID"
        caption="Event ID"
        data-type="number"
        :width="100"
      />
      <dx-column
        data-field="sortierdatum"
        caption="Sort-Date"
        data-type="date"
        format="dd.MM.yyyy"
        :width="150"
      />
      <dx-column
        data-field="themeEN"
        caption="Theme EN"
        :encodeHtml="false"
        :width="250"
      />
      <dx-column
        data-field="eventlistTitleEN"
        caption="Eventlist Title EN"
        cell-template="eventListTemplate"
        :encodeHtml="false"
        :width="250"
      />
      <dx-column
        data-field="eventSignupAffirmIDId"
        caption="Affirmation"
        :encodeHtml="false"
        :width="250"
      >
        <dx-lookup
          :data-source="affirmationTypes"
          display-expr="affirmationEN"
          value-expr="field_001"
        />
      </dx-column>
      <dx-column
        caption="Venture Challenge at ETH Zurich"
        :visible="ventureChallengeETHZurich"
        :width="200"
      >
        <dx-column
          data-field="crmBestellungEventGlobals[0].ateHowworkshopcreatevalueforproject"
          caption="How will this workshop create business value for your project?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].ateWhichmilestonesyouplannext3to9months"
          caption="Which milestones do you plan to achieve in the next 3 to 9 months?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
      </dx-column>
      <dx-column
        caption="Ask the investor / Ask the Expert"
        :visible="askInvestorExport"
        :width="200"
      >
        <dx-column
          data-field="crmBestellungEventGlobals[0].atiatepEquityhaveraised"
          caption="How much equity have you raised so far in CHF?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].atiatepComment"
          caption="Comment"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
      </dx-column>
      <dx-column
        caption="-Swiss South African Venture Leaders / Academia-Industry Training Camp / Swiss-African Science and Business Innovators (SASBI) / Food Scale Up Day"
        :visible="swissSouthVL"
        :width="200"
      >
        <dx-column
          data-field="crmBestellungEventGlobals[0].saQuestion01"
          caption="Question 1"
          :allow-hiding="false"
          :encodeHtml="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].saQuestion02"
          caption="Question 2"
          :allow-hiding="false"
          :encodeHtml="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].saQuestion03"
          caption="Question 3"
          :allow-hiding="false"
          :encodeHtml="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].saQuestion04"
          caption="Question 4"
          :allow-hiding="false"
          :encodeHtml="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].saQuestion05"
          caption="Question 5"
          :allow-hiding="false"
          :encodeHtml="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].saQuestion06"
          caption="Question 6"
          :allow-hiding="false"
          :encodeHtml="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].intlspinoff"
          caption="Uni spin-off (Food Scale Up Day)"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
      </dx-column>
      <dx-column
        caption="SIX Education Seminar"
        :visible="sixEducationSeminar"
        :width="200"
      >
        <dx-column
          data-field="crmBestellungEventGlobals[0].sixHowmuchequityhaveyouraisedsofarinCHF"
          caption="How much equity have you raised so far in CHF?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].sixWhatisyouraccountingstandard"
          caption="What is your accounting standard?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].sixWhatisyourlatestpaidvaluation"
          caption="What is your latest paid valuation (latest round of funding):"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].sixWhyshouldyourcompanyselectedfortheIPO"
          caption="Why should your company be selected for the IPO education program?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].sixComment"
          caption="Comment"
          :allow-hiding="false"
          :encodeHtml="false"
          :width="300"
        />
      </dx-column>
      <dx-column
        caption="Product Scale-Up Coaching with Zühlke / IP Workshop with Rentsch Partner AG / Mars Habitat Challenge "
        :visible="productScaleUp"
        :width="200"
      >
        <dx-column
          data-field="crmBestellungEventGlobals[0].spsDescribeyourbusinesscase"
          caption="Describe your business case"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].spsWhyshouldyouwin"
          caption="Why should your project be selected?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
      </dx-column>
      <dx-column
        caption="Scale up Bootcamp"
        :visible="scaleUpBootcamp"
        :width="200"
      >
        <dx-column
          data-field="crmBestellungEventGlobals[0].subcCoremissioncompany"
          caption="What is the core mission of your company?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].subCpropositionofferingcustomers"
          caption="What is the value proposition you are offering to your customers?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].subcCurrentcustomerkeyreferences"
          caption="What is your current customer base and who are your key references?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].subC3Swisscorporatespartners"
          caption="Which 3 Swiss corporates would you like to win as partners?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].subcCoorperationtargeting"
          caption="What form of coorperation are you targeting (pilot, investment, customer-supplier relationship)?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
      </dx-column>
      <dx-column
        caption="Swisscom StartUp Challenge"
        :visible="swisscomStartupChallenge"
        :width="200"
      >
        <dx-column
          data-field="crmBestellungEventGlobals[0].sucImpactyourcompany"
          caption="How would the Swisscom StartUp Challenge impact your company/project?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].sucExpect025GInfrastructure"
          caption="What do you expect from Swisscom experts and potential access to Swisscom Infrastructure?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].sucIconfirmthesolerightstothetechnology"
          caption="How would Swisscom Infrastructure (Network, IT environment, Security etc.) help you demonstrate your solution?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].sucInterestedinpartneringwithSwisscom"
          caption="Why are you interested in partnering with Swisscom?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].sucExpectambition01SiliconValley"
          caption="One selected start-up receives an invitation including networking at our Swisscom Outpost in Silicon Valley (US). What is your start-up ambition for a trip to the US?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].whoownsthetechnologyandIPrights"
          caption="Who owns the technology and IP rights?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
      </dx-column>
      <dx-column
        caption="Innosuisse"
        :visible="innosuisse"
        :width="200"
      >
        <dx-column
          data-field="crmBestellungEventGlobals[0].supportfromotherOrganisations"
          caption="Have you already received support from other organisations? (Bridge SNSF, Venture Kick, Venturelab, etc.)"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
      </dx-column>
      <dx-column
        caption="VL Technology / VL Medtech / VL Fintech / VL Mobile"
        :visible="vlTechnologyMedtechMobile"
        :width="200"
      >
        <dx-column
          data-field="crmBestellungEventGlobals[0].vL1Currentinternationalizationstatus"
          caption="1. What is your current internationalization status? Do you already have business on-going abroad? If yes, in which countries?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].vL2Whatareyourgrowthobjectives"
          caption="2. What are your growth objectives?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].vL3tangibleresults"
          caption="3. What are 3 tangible results that you would like to achieve during the Venture Leaders program?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].vL4Impactthedevelopmentofyourstartup"
          caption="4. How would a participation to the Venture Leaders program impact the development of your startup?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobals[0].vL5keycontributionstotheventureleaders"
          caption="5. What would be your key contributions to the #EventpoolTitel# team? Why should you be nominated?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
      </dx-column>
      <dx-column
        caption="Venture Leaders Deeptech (ex. China) / Venture Leaders Biotech"
        :visible="VLDeeptechBiotech"
        :width="200"
      >
        <dx-column
          data-field="crmBestellungEventGlobalsChina[0].whatisyourcurrentinternationalizationstatus1"
          caption="What is your current internationalization status? Do you already have business on-going in China? Why would you like to go to China?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobalsChina[0].whichstepstoprotectyourproducts2"
          caption="Which steps have you taken to protect your products regarding the Chinese market?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobalsChina[0].whatareyourobjectivesinterms3"
          caption="What are your objectives in terms of company growth in 3 - 5 years. How can China contribute to this?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobalsChina[0].whoareyourtargetcustomersinAsia5"
          caption="Who are your target customers in Asia? (Please mention specific companies.)"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobalsChina[0].howwouldvleadersChinaimpactyourcompany6"
          caption="How would venture leaders Deeptech / Biotech impact your company?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobalsChina[0].tangibleresultstoachievewhileinChina73"
          caption="What are 3 tangible results that you would like to achieve while in China? What kind of people could be helpful to you?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobalsChina[0].yourcommunicationpitchingskills8"
          caption="What demonstrates your communication / pitching skills?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
        <dx-column
          data-field="crmBestellungEventGlobalsChina[0].yourkeycontributionsshouldyoubenominated9"
          caption="What would be your key contributions to the venture leaders Deeptech / Biotech team? Why should you be nominated?"
          :encodeHtml="false"
          :allow-hiding="false"
          :width="300"
        />
      </dx-column>
      <template #eventListTemplate="{ data }">
        <div v-if="data.data.eventlistTitleEN">{{data.data.eventlistTitleEN}}</div>
        <div v-else>{{data.data.eventlistTitleDE}}</div>
      </template>
    </dx-data-grid>
  </div>
</template>

<script>
  import {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxColumnChooser,
    DxColumnChooserSearch,
    DxLookup
  } from 'devextreme-vue/data-grid'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      DxDataGrid,
      DxColumn,
      DxPaging,
      DxColumnChooser,
      DxColumnChooserSearch,
      DxLookup
    },
    props: {
      orderData: {
        type: Object,
        default: () => ({})
      }
    },
    data: () => ({
      ventureChallengeETHZurich: false,
      askInvestorExport: false,
      swissSouthVL: false,
      sixEducationSeminar: false,
      productScaleUp: false,
      scaleUpBootcamp: false,
      swisscomStartupChallenge: false,
      innosuisse: false,
      vlTechnologyMedtechMobile: false,
      VLDeeptechBiotech: false
    }),
    mounted () {
      this.displayNonEmptyColumnHeaders()
    },
    methods: {
      displayNonEmptyColumnHeaders () {
        for (const order in this.orderData.data._formatted.crmbestellungen) {
          const orders = this.orderData.data._formatted.crmbestellungen
          if (orders[order].crmBestellungEventGlobals.length > 0) {
            if (!this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].ateHowworkshopcreatevalueforproject) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].ateWhichmilestonesyouplannext3to9months)) {
              this.ventureChallengeETHZurich = true
            }
            if (!this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].atiatepEquityhaveraised) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].atiatepComment)) {
              this.askInvestorExport = true
            }
            if (!this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].saQuestion01) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].saQuestion02) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].saQuestion03) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].saQuestion04) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].saQuestion05) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].saQuestion06) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].intlspinoff)) {
              this.swissSouthVL = true
            }
            if (!this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].sixHowmuchequityhaveyouraisedsofarinCHF) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].sixWhatisyouraccountingstandard) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].sixWhatisyourlatestpaidvaluation) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].sixWhyshouldyourcompanyselectedfortheIPO) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].sixComment)) {
              this.sixEducationSeminar = true
            }
            if (!this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].spsDescribeyourbusinesscase) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].spsWhyshouldyouwin)) {
              this.productScaleUp = true
            }
            if (!this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].subcCoremissioncompany) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].subCpropositionofferingcustomers) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].subcCurrentcustomerkeyreferences) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].subC3Swisscorporatespartners) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].subcCoorperationtargeting)) {
              this.scaleUpBootcamp = true
            }
            if (!this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].sucImpactyourcompany) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].sucExpect025GInfrastructure) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].sucIconfirmthesolerightstothetechnology) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].sucInterestedinpartneringwithSwisscom) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].sucExpectambition01SiliconValley) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].whoownsthetechnologyandIPrights)) {
              this.swisscomStartupChallenge = true
            }
            if (!this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].supportfromotherOrganisations)) {
              this.innosuisse = true
            }
            if (!this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].vL1Currentinternationalizationstatus) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].vL2Whatareyourgrowthobjectives) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].vL3tangibleresults) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].vL4Impactthedevelopmentofyourstartup) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobals[0].vL5keycontributionstotheventureleaders)) {
              this.vlTechnologyMedtechMobile = true
            }
          }
          if (orders[order].crmBestellungEventGlobalsChina.length > 0) {
            if (!this.isEmptyValues(orders[order].crmBestellungEventGlobalsChina[0].whatisyourcurrentinternationalizationstatus1) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobalsChina[0].whichstepstoprotectyourproducts2) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobalsChina[0].whatareyourobjectivesinterms3) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobalsChina[0].whoareyourtargetcustomersinAsia5) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobalsChina[0].howwouldvleadersChinaimpactyourcompany6) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobalsChina[0].tangibleresultstoachievewhileinChina73) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobalsChina[0].yourcommunicationpitchingskills8) ||
              !this.isEmptyValues(orders[order].crmBestellungEventGlobalsChina[0].yourkeycontributionsshouldyoubenominated9)) {
              this.VLDeeptechBiotech = true
            }
          }
        }
      },
      isEmptyValues (value) {
        return value === undefined || value === null
      }
    },
    computed: {
      ...mapGetters({
        affirmationTypes: 'basicValues/AFFIRMATION_TYPES'
      })
    }
  }
</script>

<style lang="scss">
  .master-detail-list {
    em {
      font-style: normal;
      background: #e4135973;
      padding: 0px;
    }
  }
</style>
